exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-button[data-v-36240fc7] {\n  background: #B1B1B1;\n  color: #1B2638;\n}\n.collapse-button.active[data-v-36240fc7] {\n  background: #1B2638;\n  color: #FFFFFF;\n}\n.go-back-form[data-v-36240fc7] {\n  height: 100%;\n}\nbutton[data-v-36240fc7] {\n  height: 100%;\n}", ""]);

// exports
